import gazelleBlue from './blue/blue.module';
import gazelleAnalytics from './analytics/analytics.module';

import gazelleConfig from './core.config';
import gazelleRun from './core.run';
import trustImagesConfig from './trust-images.config';

import './core.scss';

export default angular.module('gazelle.core', [
  gazelleBlue,
  gazelleAnalytics,
  'ngMaterial',
  'rhino.core',
])
  .config(trustImagesConfig)
  .config(gazelleConfig)
  .run(gazelleRun)
  .name;
